export default "__VITE_ASSET__0$3KGztT__"